<app-view-title Title="{{ 'Intellitrailer.MyPage.MyCampaings.Title' | translate : 'My offers' }}" mode="soft"></app-view-title>
<view-content [centered]="true">
  <mat-tab-group  (selectedTabChange)="onTabChange($event)" mat-stretch-tabs>
    <mat-tab label="{{ 'Intellitrailer.MyPage.MyCampaings.btnActiveCampaigns' | translate : 'Available' }}">
      <ng-container *ngFor="let campaign of activeCampaigns">
        <app-campaign-card [(campaign)]="campaign"></app-campaign-card>
      </ng-container>
        @if(activeCampaigns.length <= 0) { <p> {{ 'Intellitrailer.MyPage.MyCampaings.msgNoCurrentOffers' | translate : 'You have no current offers.' }}</p> }
    </mat-tab>
    <mat-tab label="{{ 'Intellitrailer.MyPage.MyCampaings.btnHistoricCampaigns' | translate : 'Used / Expired' }}">
      <ng-container *ngFor="let campaign of expiredCampaigns">
        <app-campaign-card [(campaign)]="campaign" historical="true"></app-campaign-card>
      </ng-container>
    </mat-tab>
  </mat-tab-group>
</view-content>
